<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch15"></a><a id="page_16"></a><a href="#/contents#ch15"><b>Transportation</b></a></h2>
<p class="noindent"><span>On average, a commercial airplane in the United States gets struck by lightning at least once a year.</span></p>
<p class="noindent"><span>The first car manufacturer to introduce seat belts: Saab, in 1958.</span></p>
<p class="noindent"><span>China’s Shanghai Maglev Train is the world’s fastest passenger train. It reaches speeds of more than 250 mph.</span></p>
<p class="noindent"><span>There are about 600 million passenger cars in the world, one for every 11 people.</span></p>
<p class="noindent"><span>First monorail in the United States: the Disneyland Monorail System, which opened in 1959.</span></p>
<p class="noindent"><span>Motorola’s first products were car radios. The company’s name is a combination of “motor” and “Victrola.”</span></p>
<p class="noindent"><span>Germany was the first nation to develop rocket-powered aircraft, during World War II.</span></p>
<p class="noindent"><span>First member of the British royal family to fly in a jet: the Queen Mother, in 1952.</span></p>
<p class="noindent"><span>The word “train” comes from the Latin <i>trahere</i>, meaning to pull or draw.</span></p>
<p class="noindent"><span>Very early automobile models didn’t have steering wheels. Drivers used a lever to control the car’s direction.</span></p>
<p class="noindent"><span>The first commercial jet—the de Havilland Comet—made its inaugural flight in 1952.</span></p>
<p class="noindent"><span>The first flying device: the Pigeon, invented around 400 BC, looked like a bird and was propelled by steam.</span></p>
<p class="noindent"><span>World’s steepest railroad: Switzerland’s Pilatus Railway. It climbs 7,000 feet to the top of Mt. Pilatus at a grade of 48 percent.</span></p>
<p class="noindent"><span>Most car horns in the United States beep in the key of F.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter15.vue?6e216bdc